export const mainCategories = [
  'GPU',
  'CPU',
  'Motherboard',
  'RAM',
  'SSD',
  'PSU',
  'Casing',
  'Fan',
  'Monitor',
  'CPU Cooler'
];
